// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ButtonWrapper = styled.div({
  position: 'relative'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ChildrenWrapper = styled.div({
  paddingRight: "var(--ds-space-200, 16px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var StyledChevron = styled.div({
  background: 0,
  border: 0,
  height: "var(--ds-space-300, 24px)",
  outline: 0,
  padding: 0,
  position: 'absolute',
  right: '0px',
  top: '50%',
  marginTop: "var(--ds-space-negative-075, -7px)",
  width: "var(--ds-space-300, 24px)",
  display: 'flex',
  justifyContent: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var StyledClose = styled.div({
  background: 0,
  border: 0,
  height: "var(--ds-space-300, 24px)",
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 1,
  outline: 0,
  padding: 0,
  position: 'absolute',
  right: "var(--ds-space-negative-050, -4px)",
  top: '50%',
  marginTop: "var(--ds-space-negative-150, -12px)",
  width: "var(--ds-space-300, 24px)"
});